import React, { Component } from 'react';
import {
    faUserCircle,
    faPlus,
    faBullhorn,
    faHistory,
    faUsers,
    faPlane,
    faMapSigns,
    faBed,
    faBus,
    faCar,
    faPaperPlane,
    faChevronCDown,
    faChevronDown,
    faChevronRight
  } from "@fortawesome/free-solid-svg-icons";
   import {
    NavLink, 
    } from "reactstrap";
    import { withRouter } from "react-router-dom";
    import { connect } from 'react-redux';
  import { addAnn } from "../../slices/modalSlice";
  import FormControlLabel from '@mui/material/FormControlLabel';
  import { styled } from '@mui/material/styles';
  import Calender from '../../components/common/calender';
  import Switch from '@mui/material/Switch';
  import DashCatego from "../../components/Admin/dashCatego";
  import DashMenuItem from "../../components/Admin/dashMenuItem";
  import Dashannounce from "../../components/Admin/dashAnnounce";
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DashAnnDetail from './dashAnnDetail';


  const Android12Switch = styled(Switch)(({ theme }) => ({
    padding: 8,
    '& .MuiSwitch-track': {
      borderRadius: 22 / 2,
      '&:before, &:after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: 16,
        height: 16,
      },
      '&:before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main),
        )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
        left: 12,
      },
      '&:after': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main),
        )}" d="M19,13H5V11H19V13Z" /></svg>')`,
        right: 12,
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      width: 16,
      height: 16,
      margin: 2,
    },
  }));
  
class DashAnnounce extends Component {
    render() {
        return (
            <div>
                <hr style={{margin : "0px"}}/>
                <div className="dash__ann__stat mb-1  d-flex align-items-center">
                  <div className="col-5 d-flex justify-content-between align-items-center">
                  <a  data-toggle="collapse" href={"#"+this.props.id} role="button" aria-expanded="false" aria-controls={this.props.id}>
                  <h6 className="ann__card__stat mt-3" ><FontAwesomeIcon icon={faChevronDown} className="mr-3" />{this.props.name}</h6>
                </a>
                    <div className="dash__ann__actions d-flex align-items-center">
                      <img src="/imgs/dash/edit.svg" className="ann__actions" alt="" />
                      {/* <img src="/imgs/dash/times.svg"className="ann__actions ml-2" alt="" /> */}
                      <img src="/imgs/dash/boost.svg"className="ann__actions ml-2" alt="" />
                    </div>
                  </div>
                  
                  <div className="ann__stats mt-2  col-7 row mx-0 px-0 d-flex align-items-center">
                    <span className="col-4 pr-0 text-center"><h6 className="ann__card__stat">{this.props.actual}/{this.props.all}</h6></span>
                    <span className="col-4 pr-0 text-center"><h6 className="ann__card__stat">{this.props.vues}</h6></span>
                    <span className="col-4 pr-0 pl-5 mr-0  text-center"><FormControlLabel
                       control={<Android12Switch defaultChecked={this.props.share} />}
                       label=""/>
                    </span>
                  </div>
                </div>
                <div class="collapse mb-2 mt-0" id={this.props.id}>
                  <DashAnnDetail from="12/09/2021" to="20/09/2021" client="Faycal Laroum"/>
                  <DashAnnDetail from="12/09/2021" to="20/09/2021" client="Imad Mansour"/>
                  <DashAnnDetail from="12/09/2021" to="20/09/2021" client="Mmed Amin Mesmoudi"/>
                </div> 
            </div>
        );
    }
}

export default DashAnnounce;
